<template>
  <div>
    <v-container fill-height fluid>
    <v-row>
      <v-flex xs3 class="mr-2">
        <Search
          v-model="filters.search"
          :label="$t('SEARCH')"
          prepend-icon="search"
          :delay="500"
        />
      </v-flex>
      <v-spacer></v-spacer>
    </v-row>
    </v-container>
    <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="totalItems"
      :no-data-text="$t('NO_DATA')"
      :no-results-text="$t('NO_DATA')"
      hide-default-footer
      :options.sync="pagination"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:item.enabled="{ item }">
          <v-icon
            v-if="isEnabled(item.name)"
            class="green--text"
            :title="$t('ACTIVE')"
          >
            check_box
          </v-icon>
          <v-icon
            v-else
            class="red--text"
            :title="$t('INACTIVE')"
          >
            cancel
          </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  import { groupsService } from '../../../utils/services/groups.service';
  import { usersService } from '../../../utils/services/users.service';
  import Search from '../../shared/Inputs/Search';

  export default {
    name: 'UserGroups',
    components: { Search },
    props: {
      user: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
          loading: false,
          items: [],
          selected: [],
          totalItems: 0,
          pagination: {
            page: 1,
            itemsPerPage: 10,
            sortDesc: [false],
            sortBy: ['name'],
          },
          headers: [
            {
              text: this.$t('fields.id'),
              align: 'left',
              value: 'id',
            },
            { text: this.$t('fields.enabled'), value: 'enabled' },
            { text: this.$t('fields.name'), value: 'name' },
          ],
          filters: {
            search: null,
          },
      };
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),
      isEnabled(groupName) {
        return this.selected.includes(groupName);
      },
      async fetchGroups(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return groupsService.index({
          page: page || forcePage || 1,
          itemsPerPage,
        })
        .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      async fetchUserPermissions() {
        return usersService.getUserPermission()
        .then(response => {
          this.selected = response.data.roles;
        })
        .catch(error => {
          this.handleError(error, this.errors);
        });
      },
    },
    async created() {
      await this.fetchUserPermissions();
      await this.fetchGroups(1);
    },
  };
</script>
